import styled, { css } from 'styled-components'

import { Color } from 'root-constants'

import { LABEL_FADE_MS } from './constants'

export const StyledLoadingProgress = {
  Loading: styled.div<{ $labelColor?: string; $isHidden: boolean }>`
    margin-bottom: 16px;

    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: center;
    color: ${({ $labelColor = Color.WHITE }) => $labelColor};
    opacity: ${({ $isHidden }) => ($isHidden ? 0 : 1)};
    transition: opacity ${LABEL_FADE_MS}ms ease-in-out;
  `,
  ProgressWrapper: styled.div<{ $hasWhiteTrack: boolean }>`
    position: relative;
    max-width: 327px;
    width: 100%;
    height: 28px;
    margin: 0 auto 16px;
    padding: 4px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(7px);

    ${({ $hasWhiteTrack }) =>
      $hasWhiteTrack &&
      css`
        height: 24px;
        padding: 3px;
        background: ${Color.WHITE};
      `}
  `,
  ProgressInner: styled.div`
    height: 100%;
    border-radius: 999px;
    overflow: hidden;
  `,
  ProgressText: styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    color: ${Color.INK_DARKEST};
  `,
}
